import './banner.scss'
import './banner'


// WEBPACK FOOTER //
// ./resources/views/partials/home/banner/banner.js